<template>
    <div>
        <h2 style="padding-top: 10px;">燃气用具管理</h2>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table style="width: 100%;" :height="height * 0.65" :columns="columns" :data="data" 
            stripe highlight-row @on-current-change="onSelectionTableChange"></Table>
        <Modal title="Title" v-model="isAddModalShow" :mask-closable="false" width="380">
            <p slot="header" style="color:#0066FF;text-align:center">
                <span>添加燃气用具</span>
            </p>

            <Form ref="formGasApplication" :label-width="100" :rules="ruleForm" :model="formGasApplication" style="padding-top: 10px;">
                <FormItem prop="selectCondition" label="用具类型：">
                    <Select @on-change="changeSelect" v-model="formGasApplication.selectCondition">
                        <Option v-for="(item, index) in gasApplicationList" :value="JSON.stringify(item)">{{item.contrastGasAppliancesName}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="expiredate" label="功率：">
                    <Input v-model="formGasApplication.power">
                        <span slot="append">kw</span>
                    </Input>
                </FormItem>
                <FormItem prop="expiredate" label="数量：">
                    <Input v-model="formGasApplication.amount">
                    </Input>
                </FormItem>
                <FormItem prop="fixdate" label="安装日期：">
                    <Tooltip placement="top" :disabled="formGasApplication.fixdate == undefined || formGasApplication.fixdate == ''"
                        transfer :content="
                (()=>{
                  if(formGasApplication.fixdate != undefined && formGasApplication.fixdate != ''){
                    
                    return dateFtt('yyyy-MM-dd hh:mm:ss', formGasApplication.fixdate);
                  }
                })()
                ">
                        <DatePicker v-model="formGasApplication.fixdate" style="width:100%;text-align:center" type="date"
                            placeholder="请选择安装日期"></DatePicker>
                    </Tooltip>
                </FormItem>
                <FormItem prop="circle" label="使用寿命：">
                    <Input style="width:50%" :on-change="calculationExpireDate()" v-model="formGasApplication.circle"
                        placeholder="请输入使用寿命"></Input>
                    <Select style="width:50%" v-model="formGasApplication.circleunit">
                        <Option value="年">年</Option>
                        <Option value="月">月</Option>
                        <Option value="周">周</Option>
                        <Option value="日">日</Option>
                    </Select>
                </FormItem>
                <FormItem prop="expiredate" label="到期更换日期：">
                    <Input v-model="formGasApplication.expiredate" disabled></Input>
                </FormItem>
                <FormItem prop="isremind" label="到期是否提醒：">
                    <Select v-model="formGasApplication.isremind">
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </FormItem>
            </Form>
            <Button ref="responseButton" :type="buttonType" size="large" long @click="commitAdd" :loading="isLoadingButton">{{buttonMsg}}</Button>
            <div slot="footer">
                <!-- <Button icon="md-search" type="info" size="large" long>确定</Button> -->
            </div>
        </Modal>

        <Modal title="Title" v-model="isChangeModalShow" :mask-closable="false" width="380">
            <p slot="header" style="color:#0066FF;text-align:center">
                <span>更换燃气用具</span>
            </p>

            <Form ref="formChangeGasApplication" :label-width="100" :rules="ruleForm" :model="formChangeGasApplication"
                style="padding-top: 10px;">
                <FormItem prop="selectCondition" label="已安装用具：">
                    <Select @on-change="changeSelect" v-model="formChangeGasApplication.selectCondition">
                        <Option v-for="(item, index) in data" :value="JSON.stringify(item)">{{item.gasAppliancesExpireDatestamp +"到期 " + item.contrastGasAppliancesName}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="expiredate" label="功率：">
                    <Input v-model="formChangeGasApplication.power">
                        <span slot="append">kw</span>
                    </Input>
                </FormItem>
                <FormItem prop="expiredate" label="数量：">
                    <Input v-model="formChangeGasApplication.amount">
                    </Input>
                </FormItem>
                <FormItem prop="fixdate" label="安装日期：">
                    <Tooltip placement="top" :disabled="formGasApplication.fixdate == undefined || formGasApplication.fixdate == ''"
                        transfer :content="
                (()=>{
                  if(formGasApplication.fixdate != undefined && formGasApplication.fixdate != ''){
                    
                    return dateFtt('yyyy-MM-dd hh:mm:ss', formGasApplication.fixdate);
                  }
                })()
                ">
                        <DatePicker v-model="formChangeGasApplication.fixdate" style="width:100%;text-align:center"
                            type="date" placeholder="请选择安装日期"></DatePicker>
                    </Tooltip>
                </FormItem>
                <FormItem prop="circle" label="使用寿命：">
                    <Input style="width:50%" :on-change="calculationExpireDate()" v-model="formChangeGasApplication.circle"
                        placeholder="请输入使用寿命"></Input>
                    <Select style="width:50%" v-model="formChangeGasApplication.circleunit">
                        <Option value="年">年</Option>
                        <Option value="月">月</Option>
                        <Option value="周">周</Option>
                        <Option value="日">日</Option>
                    </Select>
                </FormItem>
                <FormItem prop="expiredate" label="到期更换日期：">
                    <Input v-model="formChangeGasApplication.expiredate" disabled></Input>
                </FormItem>
                <FormItem prop="isremind" label="到期是否提醒：">
                    <Select v-model="formChangeGasApplication.isremind">
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </FormItem>
            </Form>
            <Button ref="responseButton" :type="buttonType" size="large" long @click="commitChange" :loading="isLoadingButton">更换用具</Button>
            <div slot="footer">
                <!-- <Button icon="md-search" type="info" size="large" long>确定</Button> -->
            </div>
        </Modal>
        
        <!-- 模态框delete -->
        <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ed4014;text-align:center">
                <Icon type="md-create" />
                <span>删除燃气用具管理</span>
            </p>
            <div style="color:#ed4014;text-align:center">
                是否确认删除所选燃气用具管理？
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
            </div>
        </Modal>

        <div>
            <Row span="24" :gutter="16">
                <Col span=8>
                    <Button ref="showAddButton" type="primary" size="large" long @click="showAddModal"
                        :loading="isLoadingButton">添加用具</Button>
                </Col>
                <Col span=8>
                    <Button ref="showChangeButton" type="primary" size="large" long @click="showChangeModal"
                        :loading="isLoadingButton">更换用具</Button>
                </Col>
                <Col span=8>
                    <Button ref="showDeleteButton" type="primary" size="large" long @click="showDeleteModal"
                        :loading="isLoadingButton">删除用具</Button>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
    import { brotliCompress } from "zlib";
    export default {
        mounted() {
            this.formGasApplication.fixdate = global.dateFtt("yyyy-MM-dd", new Date());
            this.formChangeGasApplication.fixdate = global.dateFtt(
                "yyyy-MM-dd",
                new Date()
            );

            this.getGasApplicationList();
            this.getGasApplicationListByUser();
            this.columns = [{
                    title: "用具名称",
                    key: "contrastGasAppliancesName",
                    width: this.width / 6
                },
                {
                    title: "安装日期",
                    key: "gasAppliancesFixDatestamp",
                    width: this.width / 6
                },
                {
                    title: "到期日期",
                    key: "gasAppliancesExpireDatestamp",
                    width: this.width / 6
                },
                {
                    title: "功率",
                    key: "gasAppliancesDetailedPower",
                    width: this.width / 6
                },
                {
                    title: "数量",
                    key: "gasAppliancesDetailedAmount",
                    width: this.width / 6
                },
                {
                    title: "状态",
                    key: "gasAppliancesState",
                    width: this.width / 6
                }
            ];
        },
        data() {
            const validateContent = (rule, value, callback) => {
                if (value.trim() == "") {
                    callback(new Error("反馈内容不能为空..."));
                } else {
                    callback();
                }
            };
            return {
                height: document.body.clientHeight,
                width: document.body.clientWidth,
                isAddModalShow: false,
                isChangeModalShow: false,
                isShowDeleteModal: false,
                buttonType: "primary",
                isLoadingButton: false,
                isSpinShow: false,
                buttonMsg: "添加用具",
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [],
                gasApplicationList: [],
                openId: "",
                meterId: "",
                formChangeGasApplication: {
                    circle: 3,
                    selectCondition: "",
                    fixdate: "",
                    circleunit: "年",
                    expiredate: "",
                    isremind: "1"
                },
                formGasApplication: {
                    circle: 3,
                    selectCondition: "",
                    fixdate: "",
                    circleunit: "年",
                    expiredate: "",
                    isremind: "1"
                },
                columns: [],
                data: [],
                ruleForm: {
                    content: [{
                        validator: validateContent,
                        trigger: "blur"
                    }]
                },
                selectedData: null
            };
        },
        methods: {
            onSelectionTableChange(currentRow) {
                this.selectedData = currentRow;
            },
            showDeleteModal() {
                if (this.selectedData) {
                    this.isShowDeleteModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            dateFtt(fmt, date) {
                return global.dateFtt(fmt, date);
            },
            handleReachEdge(dir) {
                return new Promise(resolve => {
                    if (dir > 0) {} else {
                        this.pageNo = this.pageNo + 1;
                        this.getDailyRecord();
                    }
                    resolve();
                });
            },
            changeSelect(item) {
                var object = JSON.parse(item);
                if (object.customerName != null && object.customerName != undefined) {
                    this.formChangeGasApplication.circle =
                        object.contrastGasAppliancesUsageCycle;
                    this.formChangeGasApplication.circleunit =
                        object.contrastGasAppliancesUsageCycleUnit;
                } else {
                    this.formGasApplication.circle = object.contrastGasAppliancesUsageCycle;
                    this.formGasApplication.circleunit =
                        object.contrastGasAppliancesUsageCycleUnit;
                }
            },
            showAddModal() {
                this.isAddModalShow = true;
                this.buttonType == "primary";
            },
            showChangeModal() {
                this.isChangeModalShow = true;
            },
            commitDelete() {
                let that = this;
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/deleteGasApplication",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        gasAppliancesId: that.selectedData.gasAppliancesId
                    }),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.getGasApplicationListByUser();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(){
                        that.isLoadingButton = false;
                        that.isShowDeleteModal = false;
                    }
                });
            },
            commitChange() {
                if (
                    this.formChangeGasApplication.selectCondition == "" ||
                    this.formChangeGasApplication.selectCondition == undefined
                ) {
                    this.$Modal.info({
                        title: "提示",
                        content: "请先选择用具类型"
                    });
                    return;
                }
                var that = this;
                if (that.buttonType == "primary") {
                    that.isLoadingButton = true;
                    $.ajax({
                        url: "/api/changeGasApplication",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            meterId: that.meterId,
                            type: JSON.parse(that.formChangeGasApplication.selectCondition),
                            fixdate: that.formChangeGasApplication.fixdate,
                            expiredate: that.formChangeGasApplication.expiredate,
                            remind: that.formChangeGasApplication.isremind,
                            power: that.formChangeGasApplication.power,
                            amount: that.formChangeGasApplication.amount
                        }),
                        dataType: "json",
                        success: function(data) {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function(XMLHttpRequest, textStatus) {
                            that.getGasApplicationListByUser();
                            that.isChangeModalShow = false;
                            that.isLoadingButton = false;
                        }
                    });
                }
            },
            commitAdd() {
                if (
                    this.formGasApplication.selectCondition == "" ||
                    this.formGasApplication.selectCondition == undefined
                ) {
                    this.$Modal.info({
                        title: "提示",
                        content: "请先选择用具类型"
                    });
                    return;
                }
                var that = this;
                if (that.buttonType == "primary") {
                    that.isLoadingButton = true;
                    $.ajax({
                        url: "/api/addGasApplication",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            meterId: that.meterId,
                            type: JSON.parse(that.formGasApplication.selectCondition),
                            fixdate: that.formGasApplication.fixdate,
                            expiredate: that.formGasApplication.expiredate,
                            remind: that.formGasApplication.isremind,
                            power: that.formGasApplication.power,
                            amount: that.formGasApplication.amount
                        }),
                        dataType: "json",
                        success: function(data) {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function(XMLHttpRequest, textStatus) {
                            that.getGasApplicationListByUser();
                            that.isAddModalShow = false;
                            that.isLoadingButton = false;
                        }
                    });
                }
            },
            setMeterId(param){
                this.meterId = param;
                this.getGasApplicationListByUser();
            },
            getGasApplicationListByUser() {
                var that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/getGasApplicationListByUser",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        meterId: that.meterId,
                        openId: that.openId
                    }),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.body == null) {
                            return;
                        }

                        receiveData.body.forEach(function(value, i) {
                            value.gasAppliancesFixDatestamp = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date(value.gasAppliancesFixDatestamp)
                            );

                            value.gasAppliancesExpireDatestamp = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date(value.gasAppliancesExpireDatestamp)
                            );

                            value.gasAppliancesState =
                                value.gasAppliancesState == 1 ? "正常" : "弃用";
                        });

                        that.data = receiveData.body;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(XMLHttpRequest, textStatus) {
                        that.isSpinShow = false;
                    }
                });
            },
            // 根据安装日期和使用寿命生成更换日期
            calculationExpireDate() {
                if (parseInt(this.formGasApplication.circle)) {
                    switch (this.formGasApplication.circleunit) {
                        case "年":
                            var timestamp = Math.round(this.formGasApplication.fixdate / 1000);
                            var value =
                                parseInt(this.formGasApplication.circle) * 365 * 24 * 60 * 60;
                            this.formGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        case "月":
                            var timestamp = Math.round(this.formGasApplication.fixdate / 1000);
                            var value =
                                parseInt(this.formGasApplication.circle) * 30 * 24 * 60 * 60;
                            this.formGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        case "周":
                            var timestamp = Math.round(this.formGasApplication.fixdate / 1000);
                            var value =
                                parseInt(this.formGasApplication.circle) * 7 * 24 * 60 * 60;
                            this.formGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        case "日":
                            var timestamp = Math.round(this.formGasApplication.fixdate / 1000);
                            var value =
                                parseInt(this.formGasApplication.circle) * 1 * 24 * 60 * 60;
                            this.formGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        default:
                            this.formGasApplication.expiredate = "";
                            break;
                    }
                } else {
                    this.formGasApplication.expiredate = "";
                }

                if (parseInt(this.formChangeGasApplication.circle)) {
                    switch (this.formChangeGasApplication.circleunit) {
                        case "年":
                            var timestamp = Math.round(
                                this.formChangeGasApplication.fixdate / 1000
                            );
                            var value =
                                parseInt(this.formChangeGasApplication.circle) *
                                365 *
                                24 *
                                60 *
                                60;
                            this.formChangeGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        case "月":
                            var timestamp = Math.round(
                                this.formChangeGasApplication.fixdate / 1000
                            );
                            var value =
                                parseInt(this.formChangeGasApplication.circle) *
                                30 *
                                24 *
                                60 *
                                60;
                            this.formChangeGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        case "周":
                            var timestamp = Math.round(
                                this.formChangeGasApplication.fixdate / 1000
                            );
                            var value =
                                parseInt(this.formChangeGasApplication.circle) * 7 * 24 * 60 * 60;
                            this.formChangeGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        case "日":
                            var timestamp = Math.round(
                                this.formChangeGasApplication.fixdate / 1000
                            );
                            var value =
                                parseInt(this.formChangeGasApplication.circle) * 1 * 24 * 60 * 60;
                            this.formChangeGasApplication.expiredate = global.dateFtt(
                                "yyyy-MM-dd",
                                new Date((timestamp + value) * 1000)
                            );
                            break;
                        default:
                            this.formChangeGasApplication.expiredate = "";
                            break;
                    }
                } else {
                    this.formGasApplication.expiredate = "";
                }
            },
            getGasApplicationList() {
                var that = this;
                $.ajax({
                    url: "/api/getGasApplicationList",
                    contentType: "application/json",
                    type: "get",
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }

                        that.gasApplicationList = data.body;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(XMLHttpRequest, textStatus) {}
                });
            },
            showCustomerDetails(param) {
                this.formGasApplication.selectCondition = "申述";
                this.formGasApplication.meterId = param.meterId;
                this.formGasApplication.customerName = param.customerName;
                this.formGasApplication.phoneNumber = param.cutomerPhone;
                this.formGasApplication.address = param.completeAddress;
                this.buttonType = "primary";
            }
        }
    };
</script>

<style>
</style>
